import { useState } from 'react';

interface AdminSidebarProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}

const AdminSidebar = ({ activeSection, setActiveSection }: AdminSidebarProps) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const menuItems = [
    { id: 'companies', icon: 'ri-building-line', title: 'Company Management', subtitle: 'Manage client companies' },
    { id: 'users', icon: 'ri-user-line', title: 'User Management', subtitle: 'Manage user accounts' },
    { id: 'pages', icon: 'ri-pages-line', title: 'Page Management', subtitle: 'Edit all website pages' },
    { id: 'code-editor', icon: 'ri-code-line', title: 'Code Editor', subtitle: 'Direct code editing' },
    { id: 'file-manager', icon: 'ri-folder-line', title: 'File Manager', subtitle: 'Manage project files' },
    { id: 'whitelabel', icon: 'ri-palette-line', title: 'Whitelabel Settings', subtitle: 'Configure branding options' },
    { id: 'analytics', icon: 'ri-bar-chart-line', title: 'Analytics', subtitle: 'View platform analytics' },
    { id: 'billing', icon: 'ri-money-dollar-circle-line', title: 'Billing & Plans', subtitle: 'Manage subscriptions' },
    { id: 'security', icon: 'ri-shield-line', title: 'Security', subtitle: 'Security settings' },
    { id: 'system', icon: 'ri-server-line', title: 'System Status', subtitle: 'Monitor system health' },
    { id: 'logs', icon: 'ri-file-list-line', title: 'Activity Logs', subtitle: 'View system logs' }
  ];

  const handleSignOut = () => {
    // Navigate to home page
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
    }
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center">
            <i className="ri-admin-line text-white"></i>
          </div>
          <div className="ml-3">
            <h1 className="text-lg font-bold text-gray-900">Admin Panel</h1>
            <p className="text-xs text-gray-500">System Management</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveSection(item.id)}
            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
              activeSection === item.id
                ? 'bg-red-50 text-red-700 border border-red-200'
                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <i className={`${item.icon} mr-3 text-lg`}></i>
            <div className="text-left">
              <div className="font-medium">{item.title}</div>
              <div className="text-xs text-gray-500">{item.subtitle}</div>
            </div>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center mb-3">
          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
            <i className="ri-user-line text-gray-600"></i>
          </div>
          <div className="ml-3 flex-1">
            <p className="text-sm font-medium text-gray-900">Admin User</p>
            <p className="text-xs text-gray-500">admin@teamsday.com</p>
          </div>
          <button
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            className="p-1 text-gray-400 hover:text-gray-600"
          >
            <i className="ri-more-line"></i>
          </button>
        </div>

        {showProfileMenu && (
          <div className="space-y-1">
            <button
              onClick={() => {
                setActiveSection('profile');
                setShowProfileMenu(false);
              }}
              className="w-full flex items-center px-2 py-1 text-xs text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded"
            >
              <i className="ri-user-settings-line mr-2"></i>
              Profile Settings
            </button>
            <button
              onClick={() => {
                setActiveSection('password');
                setShowProfileMenu(false);
              }}
              className="w-full flex items-center px-2 py-1 text-xs text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded"
            >
              <i className="ri-lock-line mr-2"></i>
              Change Password
            </button>
            <button
              onClick={handleSignOut}
              className="w-full flex items-center px-2 py-1 text-xs text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded"
            >
              <i className="ri-logout-box-line mr-2"></i>
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSidebar;
